export default "__VITE_ASSET__80a6ef2f__"